import { PictureFrame } from './PictureFrame';
import { Radiator } from './Radiator';
export function createAdditionGeometryType(pRoomManager, pAddition, pType) {
    switch (pType) {
        case "Radiator":
            return (new Radiator(pRoomManager, pAddition));
        case "PictureFrame":
            return (new PictureFrame(pRoomManager, pAddition));
        default:
            break;
    }
    return (null);
}
